<script setup>
import { ref, reactive, computed } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import HideColumnsButton from '@/Shared/AGGrid/HideColumnsButton'
import ExportCSVButton from '@/Shared/AGGrid/ExportCSVButton'

const props = defineProps({
    items: {
        type: Array,
        required: true,
    },
});

const rowData = ref(props.items)

const defaultColDef = {
	sortable: true,
	filter: true,
	flex: 1,
	dataTestid: 'column',
	resizable: true,
	show: true,
}

const columnDefs = reactive([
    {
        field: 'created_at',
        headerName: 'Time of Event',
        filter: 'agDateColumnFilter',
        hide: false,
		minWidth: 200,
		// format to datetime
		valueFormatter: (params) => {
			return new Date(params.value).toLocaleString('en-GB', {
				hour: 'numeric',
				minute: 'numeric',
				second: 'numeric',
				year: 'numeric',
				month: 'short',
				day: 'numeric',
			})
		},
    },
    {
        field: 'causer_name',
        headerName: 'Initiated By',
        hide: false,
    },
    {
        field: 'causer_email',
        headerName: 'Initiated By (email)',
        hide: true,
    },
    {
        field: 'event',
        headerName: 'Type',
        hide: false,
    },
    {
        field: 'subject_type',
        headerName: 'Record Type',
        hide: false,
    },
	{
		field: 'subject_id',
		headerName: 'Record ID',
		hide: true,
	},
	{
		field: 'subject_name',
		headerName: 'Record Name',
		hide: false,
		minWidth: 280,
	},
]);

function toggleColumn(data){
	let col = columnDefs.find(x => x.field == data.field)
	col.hide = data.hide
}

const emit = defineEmits({
    'item-clicked': {
        type: Object,
        default: () => ({}),
    },
});

function rowClicked(event){
	emit('item-clicked', event.data)
}

function clickedGrid(event){
	savePageNumber()
}

function savePageNumber(event){
	if(gridApi.value) {
		localStorage.setItem('activity-list-cur-page', gridApi.value.paginationGetCurrentPage())
	}
}

const gridApi = ref(null)
function onGridReady(params) {
	gridApi.value = params.api
}

function onFirstDataRendered(params) {
	if(localStorage.getItem('activity-list-cur-page')){
		gridApi.value.paginationGoToPage(parseInt(localStorage.getItem('activity-list-cur-page')))
	}
}

// we want to be able to disable pagination if the user checks the "show all" box
const enablePagination = ref(true)
const perPage = computed(() => {
	return enablePagination.value ? 10 : props.items.length +1
})
function togglePagination(){
	enablePagination.value = !enablePagination.value
	gridApi.value.paginationSetPageSize(perPage.value)
}
const gridClasses = computed(() => {
	return enablePagination.value ? '' : 'hide-pagination'
})
</script>

<template>
    <SectionCard :full-width="true">
        <template #header>
			<div class="flex justify-between items-center">
				<span class="text-lg font-medium text-gray-900 mb-0">Activity Log</span>
			</div>
        </template>
		<ag-grid-vue
			class="ag-theme-alpine"
			:class="gridClasses"
			domLayout='autoHeight'
			:rowHeight="48"
			:columnDefs="columnDefs"
			:rowData="rowData"
			:defaultColDef="defaultColDef"
			rowSelection="none"
			animateRows="true"
			@cell-clicked="rowClicked"
			:pagination="enablePagination"
			:paginationPageSize="perPage"
			@grid-ready="onGridReady"
			@click="clickedGrid"
			@first-data-rendered="onFirstDataRendered"
		>
		</ag-grid-vue>
		
		<div class="w-full flex justify-end pr-4 pt-1">
			<HideColumnsButton
				:columnDefs="columnDefs"
				@toggle-column="toggleColumn"
			/>

			<ExportCSVButton
				:grid-api="gridApi"
			/>

			<Button
				class="mb-4 ml-1 text-xs py-1 px-2 self-end"
				color="light-grey"
				@click="togglePagination"
			>
				Show {{enablePagination ? 'All' : 'Pages'}}
			</Button>
				
		</div>
	</SectionCard>
</template>
